import { useIsClient } from 'usehooks-ts';

export const withClientOnly = <P extends object>(Component: React.ComponentType<P>) => {
  const ClientOnlyComponent = (props: P) => {
    const isClient = useIsClient();

    if (!isClient) return null;

    return <Component {...props} />;
  };

  ClientOnlyComponent.displayName = `withClientOnly(${Component.displayName})`;

  return ClientOnlyComponent;
};
